import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';

import { catchError, Observable, of, tap } from 'rxjs';

export interface AuthUser {
  email: string;
  role: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);

  private readonly _user = signal<AuthUser | null>(null);
  public readonly user = this._user.asReadonly();
  public readonly isAuthenticated = computed(() => this._user() !== null);

  public loadCurrentUser(): Observable<AuthUser | null> {
    return this.http.get<AuthUser>('/api/auth/me', { withCredentials: true }).pipe(
      tap((user) => this._user.set(user)),
      catchError(() => {
        this._user.set(null);
        return of(null);
      }),
    );
  }

  public logout(): Observable<void> {
    return this.http.post<void>('/api/auth/logout', null, { withCredentials: true }).pipe(
      tap(() => this.clear()),
      catchError(() => {
        this.clear();
        return of(void 0);
      }),
    );
  }

  public clear(): void {
    this._user.set(null);
  }

  public setUser(user: AuthUser | null): void {
    this._user.set(user);
  }
}
